import React, { Component } from "react"

import moment from "moment"
import ReactTooltip from "react-tooltip"

import Constants from "./../../../Phi/Constants"

import HSGModalComponent from "../../HSGModalComponent/HSGModalComponent"
import Validator from "../../../Components/FormComponent/Validator"

import "./InvitationRequest.css"

let PROFILE_FORM = [
    {
        key: "hsg-user-first-name",
        type: "text",
        label: "First Name",
        placeholder: "",
        value: "inFirstName",
    },
    {
        key: "hsg-user-last-name",
        type: "text",
        label: "Last Name",
        placeholder: "",
        value: "inLastName",
    },
    {
        key: "hsg-user-email",
        type: "text",
        label: "Email Address",
        placeholder: "",
        value: "inEmailAddress",
    },
    {
        key: "hsg-user-contact",
        type: "text",
        label: "Mobile Number",
        placeholder: "",
        value: "inMobileNumber",
    },
    {
        key: "hsg-user-password",
        type: "password",
        label: "Create Password",
        placeholder: "",
        value: "inPassword",
    },
]

const USER_FORM_ASSOCIATION = [
    {
        key: "hsg-association-first-name",
        type: "text",
        label: "First Name",
        placeholder: "",
        value: "inFirstName",
    },
    {
        key: "hsg-association-last-name",
        type: "text",
        label: "Last Name",
        placeholder: "",
        value: "inLastName",
    },
    {
        key: "hsg-association-class",
        type: "text",
        label: "Class",
        placeholder: "",
        value: "inClass",
        styleGroup: "col-xs-6 padding-left-0",
    },
    {
        key: "hsg-association-section",
        type: "text",
        label: "Section",
        placeholder: "",
        value: "inSection",
        styleGroup: "col-xs-6 padding-right-0",
    },
]

const USER_FORM_PASSWORD = [
    {
        key: "hsg-user-password",
        type: "password",
        label: "Password",
        placeholder: "Password",
        value: "inPassword",
        error: "errorInPassword",
    },
    {
        key: "hsg-user-conform-password",
        type: "password",
        label: "Confirm Password",
        placeholder: "Confirm Password",
        value: "inConfirmPassword",
        error: "errorInConfirmPassword",
    },
]

const INVITATION_POPUPS = {
    WITH_CHILD: 1,
    WITHOUT_CHILD: 2,
}

let SKIP_FINAL_VALIDATION = []

const STRING_MODAL_HEAD = "It will take couple of minutes to complete the registration."
const STRING_MODAL_HEAD_INVALID = "Oops!"
const STRING_MODAL_HEAD_INVITATION_SEND = (email) => `We have send another invitation on ${email}, Please check your inbox!`
const STRING_BUTTON_UPDATE_PROFILE = "UPDATE PROFILE"
const STRING_BUTTON_CREATE_PROFILE = "CREATE PROFILE"
const STRING_BUTTON_CHANGE_PASSWORD = "CHANGE PASSWORD"
const STRING_BUTTON_COPY_LINK = "COPY LINK"

const STRING_HEAD_PROFILE = "Personal Information"
const STRING_HEAD_CREDENTIALS = "Change Password"
const STRING_HEAD_ASSOCIATIONS = "Add Child"
const STRING_HEAD_ASSOCIATIONS_INFO = "Hi! you can also add associations to your account. Click here to do so."
const STRING_INVALID_MESSAGE_EXPIRED =
    "It looks like the invitation link han been expired. You can always connect with the organization to get you a new invitation link. Thanks for your time, hope to see you soon again!"
const STRING_INVALID_MESSAGE_USED =
    "It looks like the invitation link has been used before. You can try Signing In, or if you do not remember your username you can connect with your organization to generate another invitation link. Thanks for your time, hope to see you soon again!"
const STRING_INVALID_MESSAGE_LINKED =
    "It looks like the invitation link has been Inactivated because of auto linking during your previous login. You can try Signing In, or if you do not remember your username you can connect with your organization. Thanks for your time, hope to see you soon again!"
const STRING_INVALID_MESSAGE_ERROR =
    "It looks like the invitation link your are using is not valid. Please connect with your organization to get a new one or if you remember your credentials you can try signing in. "
const STRING_HEAD_VISITOR_LINK = "Visitor's Link"
const STRING_ADD_CHILD = "Add Another Child +"

const STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN = "Email already exists in our system"
const STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN = "Phone number already exists in our system."

const STRING_WARNING_ASSOCIATION_LIMIT = "You can not add more associations"

const STRING_ERROR_EMPTY_FIELD_MESSAGE = (label) => `${label} cannot be blank`

const STRING_IN_UPDATED_WELCOME = (first, last) => `Welcome, ${first || ""} ${last || ""}`
const STRING_IN_UPDATED_WELCOME_PARENT = () => `Dear parent,`
const STRING_IN_UPDATED_ACCOUNT_REGISTER = `Please create a new password to register your account`
const STRING_IN_UPDATED_USERNAME = `Your Username is your registered Email`
const STRING_IN_UPDATED_TERMS_AND_CONDITIONS = `I agree  to Terms & Conditions`
const STRING_IN_UPDATED_BTN_SUBMIT = `Submit`

function hideEmail(email) {
    let hidden = ""
    let startFlag = true
    for (let i = 0; i < email.length; i++) {
        if (i === 0) {
            hidden += email[i]
            startFlag = false
        } else if (startFlag) {
            hidden += email[i]
        } else if (email[i + 1] === "@") {
            hidden += email[i]
            startFlag = true
        } else {
            hidden += "*"
        }
    }

    return hidden
}

export default class InvitationRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visitorsLink: null,

            inDefaultEmail: "",
            inDefaultPhone: "",

            associations: [{}],
            currentAssociationIndex: 0,
            defaultAssociationLength: 0,

            showInvitationSendMessage: false,
            skipValidation: [],

            errorIndex: {},

            currentInvitationPopup: null,

            agreedToTAndC: false,
        }
    }

    parseUser(details) {
        let name = details.name || ""

        var firstName = name.split(" ")[0]
        var lastName = name.substring(firstName.length).trim()

        this.setState({
            inFirstName: firstName,
            inLastName: lastName,
            inEmailAddress: details.email,
            inMobileNumber: details.phone,
            jwt: details.jwt,
            associationLimit: details.associationLimit,
            organizationId: details.organizationId,
            currentOrganizationId: details.currentOrganizationId,
            roleTypeId: details.roleTypeId,
            userId: details.userId,
            invitationLink: this.props.invitationLink,
            magicLink: details.magicLink,

            switchedInvitationLink: details.switchedInvitationLink,

            refIds: details.refIds || {},

            organizationName: details.organizationName,

            inDefaultEmail: details.email,
            inDefaultPhone: details.phone,

            invitationCustom: details.invitationCustom

            // makeAssociationMandate: details.roleTypeId === Constants.roleIdMap.PARENT ? true : false,
        })

        if (details.userId) {
            PROFILE_FORM[4] = {
                key: "hsg-user-password",
                type: "password",
                label: "Update Password",
                placeholder: "",
                value: "inPassword",
            }

            SKIP_FINAL_VALIDATION = SKIP_FINAL_VALIDATION.concat("inPassword")
        }
    }

    parseAssociation(details, organization, organizationName, limit, roleType) {
        let associations = details.map((element) => {
            let name = element.name || ""

            let firstName = name.split(" ")[0]
            let lastName = name.substring(firstName.length).trim()

            return {
                inFirstName: firstName,
                inLastName: lastName,
                inClass: element.inClass,
                inSection: element.inSection,
                inUserId: element.userId,
                organizationName: element.organizationName || organizationName,
                inOrganizationId: element.inOrganizationId || organization,
                inInvitationLink: element.invitationLink,
                isEditable: false,
            }
        })

        // this.setState({
        //     associations: associations.length ? associations : role === Constants.roleIdMap.PARENT ? [{}] : [],
        //     defaultAssociationLength: role === Constants.roleIdMap.PARENT ? associations.length || 1 : associations.length,
        //     currentAssociationIndex: role === Constants.roleIdMap.PARENT ? associations.length || 1 : associations.length
        // });

        // let defaultAssociationLength = 0,
        //     currentAssociationIndex = 0

        // if (associations.length < limit) {
        //     defaultAssociationLength = associations.length + 1;
        //     currentAssociationIndex = associations.length;
        //     associations = associations.concat({});
        // } else if (associations.length === limit) {
        //     defaultAssociationLength = associations.length;
        //     currentAssociationIndex = associations.length - 1;
        // } else {
        // }

        // try {
        //     associations = associations.asMutable()
        //     associations = associations.reverse()
        // } catch (e) {
        //     associations = associations || []
        // }

        // associations = limit > 0 ? associations.concat({ organizationName: organizationName }) : associations
        // defaultAssociationLength = associations.length
        // currentAssociationIndex = associations.length - 1
        // currentAssociationIndex = 0;

        // this.setState({
        //     associations: associations.length ? associations : limit > 0 ? [{ organizationName: organizationName }] : [],
        //     defaultAssociationLength,
        //     currentAssociationIndex,
        //     currentInvitationPopup:
        //         (associations && associations.length) || limit > 0 || roleType === Constants.roleIdMap.PARENT
        //             ? INVITATION_POPUPS.WITH_CHILD
        //             : INVITATION_POPUPS.WITHOUT_CHILD,
        // })

        this.setState({
            associations: associations.length ? associations : [],
        })
    }

    componentDidMount() {
        const { userDetails, userAssociations } = this.props

        this.parseUser(userDetails || {})
        this.parseAssociation(
            userAssociations || [],
            userDetails.organizationId,
            userDetails.organizationName,
            userDetails.associationLimit,
            userDetails.roleTypeId
        )
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.emailVerified &&
            !this.props.emailAvailable &&
            this.state["error" + PROFILE_FORM[2].value] !== STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN &&
            prevState[PROFILE_FORM[2].value] !== prevState.inDefaultEmail
        ) {
            this.setState({
                ["error" + PROFILE_FORM[2].value]:
                    this.state[PROFILE_FORM[2].value] === this.state.inDefaultEmail ? undefined : STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN,
            })
        }

        if (
            this.props.phoneVerified &&
            !this.props.phoneAvailable &&
            this.state["error" + PROFILE_FORM[3].value] !== STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN &&
            prevState[PROFILE_FORM[3].value] !== prevState.inDefaultPhone
        ) {
            this.setState({
                ["error" + PROFILE_FORM[3].value]:
                    this.state[PROFILE_FORM[3].value] === this.state.inDefaultPhone ? undefined : STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN,
            })
        }

        if (prevProps.userDetails !== this.props.userDetails) {
            const { userDetails, userAssociations } = this.props

            this.parseUser(userDetails || {})
            this.parseAssociation(
                userAssociations || [],
                userDetails.organizationId,
                userDetails.organizationName,
                userDetails.associationLimit,
                userDetails.roleTypeId
            )
        }
    }

    errorEmailDuplication = (element) =>
        this.state["error" + PROFILE_FORM[2].value] === STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN ? (
            <div className="hsg-error hsg-invitation-request-modal-invitation-content">
                This email address is already linked to an account,{" "}
                <span
                    className="hsg-invitation-request-modal-invitation-content click"
                    onClick={() => {
                        this.props.sendInvitationLink({
                            inEmail: this.state[element.value],
                            inPhone: "",
                            inOrganizationId: this.state.organizationId,
                            inRole: this.state.roleTypeId,
                            inName: `${this.state.inFirstName} ${this.state.inLastName}`,
                            inInvitationLink: this.state.invitationLink
                        })

                        this.setState({ showInvitationSendMessage: true })
                    }}
                >
                    Click Here
                </span>{" "}
                {/* to get an invitation link on the updated email, or{" "} */}
                {/* <span
                    className="hsg-invitation-request-modal-invitation-content click"
                    onClick={() => this.props.onClose()}
                >
                    Click Here
                </span>{" "} */}
                to get an invitation link on the updated email, or you can add a different email address to register.
            </div>
        ) : null

    errorPhoneDuplicate = () =>
        this.state["error" + PROFILE_FORM[3].value] === STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN && this.props.phoneMeta.email ? (
            <div className="hsg-error hsg-invitation-request-modal-invitation-content">
                This phone number is already linked to an account. If you own this account,{" "}
                <span
                    className="hsg-invitation-request-modal-invitation-content click"
                    onClick={() => {
                        this.props.sendInvitationLink({
                            inEmail: this.props.phoneMeta.email,
                            inPhone: this.props.userDetails.email,
                            inOrganizationId: this.state.organizationId,
                            inRole: this.state.roleTypeId,
                            inName: `${this.state.inFirstName} ${this.state.inLastName}`,
                            inInvitationLink: this.state.invitationLink,
                        })

                        this.setState({ showInvitationSendMessage: true })
                    }}
                >
                    Click Here
                </span>{" "}
                to get an invitation link on {hideEmail(this.props.phoneMeta.email || "")}, or you can add a different phone number
                {/* <span
                    className="hsg-invitation-request-modal-invitation-content click"
                    onClick={() => this.props.onClose()}
                >
                    Click Here
                </span>{" "} */}
            </div>
        ) : null

    profileFormInputSpecialResponseMap = {
        [PROFILE_FORM[2].value]: (element) => this.errorEmailDuplication(element),
        [PROFILE_FORM[3].value]: (element) => this.errorPhoneDuplicate(),
    }

    profileFormInputField = (index, element, value, onChange, error, show, icon) =>
        !show ? null : (
            <div key={index} className={element.styleGroup || ""}>
                <div className="hsg-invitation-request-modal-form-group">
                    <label className="hsg-invitation-request-modal-form-label" htmlFor={element.key}>
                        {element.label}
                    </label>
                    {/* {this.state[error] ? (
                    <i className="fa fa-info-circle hsg-auth-content-sign-up-form-error-icon" aria-hidden="true" />
                ) : null} */}
                    <input
                        name={element.key}
                        className={`hsg-invitation-request-modal-form-input ${error ? "hsg-invitation-request-modal-form-input-error" : ""}`}
                        data-tip=""
                        data-for={`${element.key}-tooltip`}
                        id={element.key}
                        placeholder={element.placeholder}
                        type={element.type}
                        value={value || ""}
                        autoComplete="disabled"
                        disabled={!onChange}
                        onChange={(e) => (onChange ? onChange(e.target.value, value, error) : null)}
                    />
                    {icon ? icon : null}
                    {this.profileFormInputSpecialResponseMap[element.value] ? this.profileFormInputSpecialResponseMap[element.value](element) : null}
                </div>
                <ReactTooltip className="hsg-auth-content-sign-up-form-error-tooltip" id={`${element.key}-tooltip`} type="error" effect="solid">
                    {error}
                </ReactTooltip>
            </div>
        )

    profileFormErrorMap = () => ({
        //First Name
        [PROFILE_FORM[0].value]: (value) =>
            Validator.requiredWithCustomMessage(value, STRING_ERROR_EMPTY_FIELD_MESSAGE("First Name")) || Validator.checkPersonName(value),
        //Last Name
        [PROFILE_FORM[1].value]: (value) =>
            Validator.requiredWithCustomMessage(value, STRING_ERROR_EMPTY_FIELD_MESSAGE("Last Name")) || Validator.checkPersonName(value),
        //Email
        [PROFILE_FORM[2].value]: (value) =>
            Validator.requiredWithCustomMessage(value, STRING_ERROR_EMPTY_FIELD_MESSAGE("Email Address")) || Validator.checkEmail(value),
        //Phone
        [PROFILE_FORM[3].value]: (value) =>
            Validator.requiredWithCustomMessage(value, STRING_ERROR_EMPTY_FIELD_MESSAGE("Mobile Number")) || Validator.indianPhoneValidator(value),
        //Password
        [PROFILE_FORM[4].value]: (value) =>
            !!!this.state.userId
                ? Validator.requiredWithCustomMessage(value, STRING_ERROR_EMPTY_FIELD_MESSAGE("Password")) ||
                  Validator.minValue(4, "Password should be 4 character or more")((value && value.length) || 0)
                : null || Validator.minValue(4, "Password should be 4 character or more")((value && value.length) || 0),
    })

    profileFormAddName = (value, key, error) =>
        this.setState({
            [key]: value,
            [error]: this.profileFormErrorMap()[key](value),
        })

    profileFormAddEmail = (value, key, error) => {
        let possibleError = this.profileFormErrorMap()[key](value)

        this.setState({
            [key]: value,
            [error]: possibleError,
        })

        if (value && !possibleError && value !== this.state.inDefaultEmail) {
            this.props.checkEmailAvailability(value)
            this.props.changeValidationResponseType("")
        }
    }

    profileFormAddPhone = (value, key, error) => {
        let possibleError = this.profileFormErrorMap()[key](value)

        this.setState({
            [key]: value,
            [error]: possibleError,
        })

        if (value && !possibleError && value !== this.state.inDefaultPhone) {
            this.props.checkPhoneNumberAvailability(value)
            this.props.changeValidationResponseType("")
        }
    }

    profileFormAddPassword = (value, key, error) =>
        this.setState({
            [key]: value,
            [error]: this.profileFormErrorMap()[key](value),
        })

    profileFormMap = () => ({
        //First Name
        [PROFILE_FORM[0].key]: (value, key, error) => this.profileFormAddName(value, key, error),
        //Last Name
        [PROFILE_FORM[1].key]: (value, key, error) => this.profileFormAddName(value, key, error),
        //Email
        [PROFILE_FORM[2].key]: (value, key, error) => this.profileFormAddEmail(value, key, error),
        //Phone
        [PROFILE_FORM[3].key]: (value, key, error) => this.profileFormAddPhone(value, key, error),
        //Password
        [PROFILE_FORM[4].key]: (value, key, error) => this.profileFormAddPassword(value, key, error),
    })

    profileForm = () => (
        <div className="padding-10">
            <div className="hsg-invitation-request-modal-form-sub-head">{STRING_HEAD_PROFILE}</div>
            <div>
                {PROFILE_FORM.map((element, index) =>
                    this.profileFormInputField(
                        index,
                        element,
                        this.state[element.value] || "",
                        (e) => this.profileFormMap()[element.key](e, element.value, "error" + element.value),
                        this.state["error" + element.value],
                        true
                    )
                )}
            </div>
        </div>
    )

    associationFormOptions = (currentAssociationIndex) => {
        let { associations, errorIndex } = this.state
        let associationLength = associations.length
        try {
            associations = associations && associations.length ? associations.asMutable() : associations
            associations = associations.reverse()
        } catch (e) {}

        return (
            <div className="hsg-invitation-request-modal-form-add-child">
                <div
                    className="hsg-invitation-request-modal-form-add-child-content"
                    onClick={() => {
                        if (this.state.defaultAssociationLength + this.state.associationLimit - 1 > this.state.associations.length) {
                            this.setState({
                                associations: this.state.associations.concat({
                                    isEditable: true,
                                    inOrganizationId: this.state.organizationId,
                                    organizationName: this.state.organizationName,
                                }),
                                currentAssociationIndex: this.state.associations.length,
                                // currentAssociationIndex: 0,
                            })
                        } else {
                            Constants.showToaster(STRING_WARNING_ASSOCIATION_LIMIT, "WARNING")
                        }
                    }}
                >
                    <span>{STRING_ADD_CHILD}</span>
                </div>
                <div className="hsg-invitation-request-modal-form-add-child-page">
                    {associations.map((element, index) => {
                        let label = associationLength - index
                        let currentIndex = label - 1

                        return (
                            <div
                                key={index}
                                className={
                                    currentAssociationIndex === currentIndex
                                        ? "hsg-invitation-request-modal-form-add-child-page-group-selected"
                                        : "hsg-invitation-request-modal-form-add-child-page-group"
                                }
                                onClick={() => this.setState({ currentAssociationIndex: currentIndex })}
                            >
                                {errorIndex[currentIndex] ? <i className="fa fa-exclamation-circle" aria-hidden="true"></i> : null}
                                <span
                                    className={
                                        currentAssociationIndex === currentIndex
                                            ? "hsg-invitation-request-modal-form-add-child-selected"
                                            : "hsg-invitation-request-modal-form-add-child"
                                    }
                                >
                                    {label}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    associationFormErrorMap = () => ({
        [USER_FORM_ASSOCIATION[0].value]: (e) =>
            Validator.requiredWithCustomMessage(e, STRING_ERROR_EMPTY_FIELD_MESSAGE("First Name")) || Validator.checkPersonName(e),
        [USER_FORM_ASSOCIATION[1].value]: (e) =>
            Validator.requiredWithCustomMessage(e, STRING_ERROR_EMPTY_FIELD_MESSAGE("Last Name")) || Validator.checkPersonName(e),
        [USER_FORM_ASSOCIATION[2].value]: (e) => Validator.requiredWithCustomMessage(e, STRING_ERROR_EMPTY_FIELD_MESSAGE("Class")),
        [USER_FORM_ASSOCIATION[3].value]: (e) => Validator.requiredWithCustomMessage(e, STRING_ERROR_EMPTY_FIELD_MESSAGE("Section")),
    })

    associationFormAdd(currentAssociation, associations, currentAssociationIndex, value, error, e) {
        currentAssociation = Object.assign({}, currentAssociation, {
            [value]: e,
            [error]: this.associationFormErrorMap()[value](e),
        })

        associations[currentAssociationIndex] = currentAssociation
        this.setState({ associations: associations })
    }

    associationFormMap(e) {
        let { currentAssociationIndex, associations } = this.state
        // Hot Fix for Converting Immutable
        associations = associations.asMutable ? associations.asMutable() : associations
        let currentAssociation = associations[currentAssociationIndex] || {}

        return {
            // First Name
            [USER_FORM_ASSOCIATION[0].key]: (value, error) => {
                this.associationFormAdd(currentAssociation, associations, currentAssociationIndex, value, error, e)
            },
            // Last Name
            [USER_FORM_ASSOCIATION[1].key]: (value, error) => {
                this.associationFormAdd(currentAssociation, associations, currentAssociationIndex, value, error, e)
            },
            // Class
            [USER_FORM_ASSOCIATION[2].key]: (value, error) => {
                this.associationFormAdd(currentAssociation, associations, currentAssociationIndex, value, error, e)
            },
            // Section
            [USER_FORM_ASSOCIATION[3].key]: (value, error) => {
                this.associationFormAdd(currentAssociation, associations, currentAssociationIndex, value, error, e)
            },
        }
    }

    associationFormContent = () => {
        let { currentAssociationIndex, associations, defaultAssociationLength } = this.state
        // Hot Fix for Converting Immutable
        associations = associations.asMutable ? associations.asMutable() : associations

        let currentAssociation = associations[currentAssociationIndex] || {}

        return (
            <div className="padding-10">
                <div className="col-xs-12 padding-0">
                    <div className="hsg-invitation-request-modal-form-sub-head">{STRING_HEAD_ASSOCIATIONS}</div>
                    {associations.length > defaultAssociationLength && currentAssociationIndex + 1 > defaultAssociationLength && (
                        <i
                            className="fa fa-times hsg-invitation-request-modal-close-button"
                            aria-hidden="true"
                            onClick={() => {
                                associations = associations.filter((element, index) => index !== currentAssociationIndex)
                                this.setState({
                                    associations,
                                    currentAssociationIndex: currentAssociationIndex >= associations.length ? associations.length - 1 : currentAssociationIndex,
                                })
                            }}
                        ></i>
                    )}
                </div>
                <div className="col-xs-12 padding-0">
                    {USER_FORM_ASSOCIATION.map((element, index) =>
                        this.profileFormInputField(
                            index,
                            element,
                            currentAssociation[element.value],
                            (e) => {
                                this.associationFormMap(e)[element.key](element.value, "error" + element.value)
                                this.setState({ errorIndex: { ...this.state.errorIndex, [currentAssociationIndex]: false } })
                            },
                            currentAssociation["error" + element.value],
                            true
                        )
                    )}
                </div>
                <div className="col-xs-12 padding-0 margin-top-20">{this.associationFormOptions(currentAssociationIndex)}</div>
            </div>
        )
    }

    associationFormInfo = () => (
        <div className="padding-10">
            <div className="col-xs-12 padding-0 margin-top-20" onClick={() => this.setState({ associations: [{}], currentAssociationIndex: 0 })}>
                <div className="hsg-invitation-request-modal-form-sub-head-info">{STRING_HEAD_ASSOCIATIONS_INFO}</div>
            </div>
        </div>
    )

    associationForm = () => {
        let { currentAssociationIndex, associations, defaultAssociationLength, associationLimit } = this.state
        // Hot Fix for Converting Immutable
        associations = associations.asMutable ? associations.asMutable() : associations

        let currentAssociation = associations[currentAssociationIndex] || {}

        return associations && associations.length ? (
            <div>{this.associationFormContent()}</div>
        ) : associationLimit > 0 ? (
            <div>{this.associationFormInfo()}</div>
        ) : null
    }

    submissionDefaultError() {
        let state = {}

        PROFILE_FORM.map((element) => {
            state = {
                ...state,
                ["error" + element.value]: this.profileFormErrorMap()[element.value](this.state[element.value]),
            }
        })

        let associations = this.state.associations
        let updatedAssociations = []
        let errorIndex = {}

        associations.map((elements, index) => {
            let newElement = elements
            let error = false

            USER_FORM_ASSOCIATION.map((element) => {
                newElement = {
                    ...newElement,
                    ["error" + element.value]: this.associationFormErrorMap()[element.value](newElement[element.value]),
                }

                error = !error ? (newElement["error" + element.value] ? true : false) : error
            })

            errorIndex = { ...errorIndex, [index]: error }
            updatedAssociations.push(newElement)
        })

        state = { ...state, associations: updatedAssociations, errorIndex: errorIndex }

        this.setState(state)
    }

    formValidation() {
        let response = {
            status: false,
            user: {},
            associations: [],
        }

        let user = {
            organizationId: this.state.organizationId,
            currentOrganizationId: this.state.currentOrganizationId,
            roleTypeId: this.state.roleTypeId,
            magicLink: this.state.magicLink,
            userId: this.state.userId,
            invitationLink: this.state.invitationLink,
            refIds: this.state.refIds,
            invitationCustom: this.state.invitationCustom
        }
        let associations = []

        const currentAssociations = this.state.associations

        for (let i = 0; i < PROFILE_FORM.length; i++) {
            if (!SKIP_FINAL_VALIDATION.includes(PROFILE_FORM[i].value) && (!this.state[PROFILE_FORM[i].value] || this.state["error" + PROFILE_FORM[i].value])) {
                return response
            } else {
                user = { ...user, [PROFILE_FORM[i].value]: this.state[PROFILE_FORM[i].value] }
            }
        }

        for (let j = 0; j < currentAssociations.length; j++) {
            let element = {
                inOrganizationId: currentAssociations[j].inOrganizationId || this.state.organizationId,
                inUserId: currentAssociations[j].inUserId,
            }

            for (let i = 0; i < USER_FORM_ASSOCIATION.length; i++) {
                if (!currentAssociations[j][USER_FORM_ASSOCIATION[i].value] || currentAssociations[j]["error" + USER_FORM_ASSOCIATION[i].value]) {
                    return response
                } else {
                    element = {
                        ...element,
                        [USER_FORM_ASSOCIATION[i].value]: currentAssociations[j][USER_FORM_ASSOCIATION[i].value],
                    }
                }
            }

            associations.push(element)
        }

        return { status: true, user, associations }
    }

    handleSubmission() {
        let { status, user, associations } = this.formValidation()
        if (status) {
            this.props.handleInvitationRequest(user, associations)
        } else {
            this.submissionDefaultError()
        }
    }

    invitationModalBodyFormPassword = () =>
        this.profileFormInputField(
            1,
            {
                key: "hsg-user-password",
                type: this.state["iconInPassword"] ? "text" : "password",
                label: "",
                placeholder: "Create Password",
                value: "inPassword",
            },
            this.state["inPassword"] || "",
            (e) => this.profileFormMap()["hsg-user-password"](e, "inPassword", "error" + "inPassword"),
            this.state["error" + "inPassword"],
            true,
            this.state["iconInPassword"] ? (
                <i
                    className="fa fa-eye-slash"
                    style={{ position: "absolute", marginTop: 12, right: 24, fontSize: 18, cursor: "pointer" }}
                    onClick={() => this.setState((pState) => ({ ["iconInPassword"]: !pState["iconInPassword"] }))}
                    aria-hidden="true"
                ></i>
            ) : (
                <i
                    className="fa fa-eye"
                    style={{ position: "absolute", marginTop: 12, right: 24, fontSize: 18, cursor: "pointer" }}
                    onClick={() => this.setState((pState) => ({ ["iconInPassword"]: !pState["iconInPassword"] }))}
                    aria-hidden="true"
                ></i>
            )
        )

    invitationModalBodyFormEmail = () =>
        this.profileFormInputField(
            2,
            {
                key: "hsg-user-email",
                type: "text",
                label: "",
                placeholder: "",
                value: "inEmailAddress",
            },
            this.state["inEmailAddress"] || "",
            (e) => this.profileFormMap()["hsg-user-email"](e, "inEmailAddress", "error" + "inEmailAddress"),
            this.state["error" + "inEmailAddress"],
            true
        )

    invitationModalBodyFormTAndC = () => (
        <div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="hsg-checkbox hsg-invitation-updated-content" style={{ margin: "13px 10px 0px 10px" }}>
                    <input
                        type="checkbox"
                        value="None"
                        id="hsg-checkbox-t-and-c"
                        name="hsg-checkbox-t-and-c"
                        // checked={this.state.agreedToTAndC}
                        onClick={() => this.setState((pState) => ({ agreedToTAndC: !pState.agreedToTAndC, errorAgreedToTAndC: false }))}
                    />
                    <label htmlFor="hsg-checkbox-t-and-c" style={{ margin: 0 }}></label>
                </div>
                <a
                    className="hsg-invitation-updated-content right"
                    style={{ textAlign: "right", cursor: "pointer" }}
                    href={`${window.location.origin}/login?data-policy`}
                    target="_black"
                >
                    {STRING_IN_UPDATED_TERMS_AND_CONDITIONS}
                </a>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <span className="hsg-error">
                    {this.state.errorAgreedToTAndC ? "Can not proceed further without agreeing to our terms and conditions." : ""}
                </span>
            </div>
        </div>
    )

    invitationModalBodyFormSubmission = () => (
        <div>
            <button
                className="hsg-btn-white right"
                style={{ color: "#31B158", fontSize: 20, fontWeight: 600, lineHeight: "24px", padding: 0, outline: "none" }}
                onClick={() => {
                    let { inEmailAddress, inPassword, errorinEmailAddress, errorinPassword, agreedToTAndC, errorAgreedToTAndC } = this.state

                    errorinPassword =
                        Validator.minValue(4, "Password should be 4 character or more")((inPassword && inPassword.length) || 0) ||
                        Validator.requiredWithCustomMessage(inPassword, STRING_ERROR_EMPTY_FIELD_MESSAGE("Password"))
                    errorinEmailAddress = this.profileFormErrorMap()["inEmailAddress"](inEmailAddress)
                    errorAgreedToTAndC = agreedToTAndC ? false : true

                    if (inEmailAddress && inPassword && agreedToTAndC && !errorinEmailAddress && !errorinPassword && !errorAgreedToTAndC) {
                        let user = {
                            organizationId: this.state.organizationId,
                            currentOrganizationId: this.state.currentOrganizationId,

                            roleTypeId: this.state.roleTypeId,
                            magicLink: this.state.magicLink,
                            userId: this.state.userId,
                            inEmailAddress: inEmailAddress,
                            inFirstName: this.state.inFirstName,
                            inLastName: this.state.inLastName,
                            inPassword: inPassword,

                            refIds: this.state.refIds,

                            invitationLink: this.state.invitationLink,
                            inSwitchedInvitationLink: this.state.switchedInvitationLink,

                            invitationCustom: this.state.invitationCustom
                        }

                        this.props.handleInvitationRequest(user, this.state.associations || [])
                    } else {
                        this.setState({
                            errorinPassword,
                            errorinEmailAddress,
                            errorAgreedToTAndC,
                        })
                    }
                }}
            >
                {STRING_IN_UPDATED_BTN_SUBMIT}
            </button>
        </div>
    )

    invitationModalBodyNonParent = () => (
        <div className="container-fluid padding-10">
            <div className="margin-top-20 decrease-input-group-margin">
                <div className="col-xs-12 hsg-invitation-updated-welcome-message margin-top-16 margin-bottom-20">
                    {STRING_IN_UPDATED_WELCOME(this.state.inFirstName, this.state.inLastName)}
                </div>
                <div className="col-xs-12 hsg-invitation-updated-content">{STRING_IN_UPDATED_ACCOUNT_REGISTER}</div>
                <div className="col-xs-12">{this.invitationModalBodyFormPassword()}</div>
                <div className="col-xs-12 hsg-invitation-updated-content">{STRING_IN_UPDATED_USERNAME}</div>
                <div className="col-xs-12">{this.invitationModalBodyFormEmail()}</div>

                <div className="col-xs-12 right">{this.invitationModalBodyFormTAndC()}</div>
                <div className="col-xs-12 margin-top-20">{this.invitationModalBodyFormSubmission()}</div>
            </div>
        </div>
    )

    invitationModalBodyParent = () => (
        <div className="container-fluid padding-10">
            <div className="margin-top-20 decrease-input-group-margin">
                <div className="col-xs-12 hsg-invitation-updated-welcome-message margin-top-16 margin-bottom-20">{STRING_IN_UPDATED_WELCOME_PARENT()}</div>
                <div className="col-xs-12 hsg-invitation-updated-content">{STRING_IN_UPDATED_ACCOUNT_REGISTER}</div>
                <div className="col-xs-12">{this.invitationModalBodyFormPassword()}</div>
                <div className="col-xs-12 hsg-invitation-updated-content">{STRING_IN_UPDATED_USERNAME}</div>
                <div className="col-xs-12">{this.invitationModalBodyFormEmail()}</div>

                <div className="col-xs-12 right">{this.invitationModalBodyFormTAndC()}</div>
                <div className="col-xs-12 margin-top-20">{this.invitationModalBodyFormSubmission()}</div>
            </div>
        </div>
    )

    render() {
        const { show, onClose, isInvalidRequest, userDetails } = this.props
        const { showInvitationSendMessage, currentInvitationPopup } = this.state

        const { associations, associationLimit, currentAssociationIndex } = this.state
        const associationEnabled = (associations && associations.length) || associationLimit || false

        let currentAssociation = {}

        if (associationEnabled) {
            currentAssociation = associations[currentAssociationIndex] || {}
        }

        const classMap = {
            profileForm: associationEnabled ? "col-xs-12 col-sm-12 col-md-6 hsg-invitation-request-modal-right-separator" : "col-xs-12",
            associationForm: associationEnabled ? "col-xs-12 col-sm-12 col-md-6" : "hidden",
        }

        // return currentInvitationPopup === INVITATION_POPUPS.WITH_CHILD || isInvalidRequest || showInvitationSendMessage ? (
        //     <HSGModalComponent
        //         show={show || false}
        //         onClose={() => onClose()}
        //         onHide={() => null}
        //         header={
        //             showInvitationSendMessage
        //                 ? STRING_MODAL_HEAD_INVITATION_SEND(hideEmail(this.props.phoneMeta.email || "") || this.state.inEmailAddress)
        //                 : isInvalidRequest
        //                 ? STRING_MODAL_HEAD_INVALID
        //                 : STRING_MODAL_HEAD
        //         }
        //         showClose={true}
        //         bsSize={associationEnabled && !showInvitationSendMessage ? "large" : null}
        //         body={
        //             <div className="container-fluid">
        //                 {/* <Loader blockUI={true} isLoading={this.props.isLoading} /> */}
        //                 {showInvitationSendMessage ? null : !isInvalidRequest ? (
        //                     <div>
        //                         <div className="col-xs-12 center" style={{ paddingBottom: 16, color: "#00ac5a", fontWeight: "bold" }}>
        //                             {currentAssociation.organizationName}
        //                         </div>
        //                         <div className="col-xs-12 hsg-invitation-request-modal-root">
        //                             <div className={classMap.profileForm}>{this.profileForm()}</div>
        //                             <div className={classMap.associationForm}>{this.associationForm()}</div>

        //                             <div className="col-xs-12 col-sm-12 center">
        //                                 <button className="hsg-btn hsg-invitation-request-modal-button-change-password" onClick={() => this.handleSubmission()}>
        //                                     {this.state.jwt ? STRING_BUTTON_UPDATE_PROFILE : STRING_BUTTON_CREATE_PROFILE}
        //                                 </button>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 ) : (
        //                     <div className="col-xs-12 hsg-invitation-request-modal-root">
        //                         {userDetails.linkSuccess === 1
        //                             ? STRING_INVALID_MESSAGE_USED
        //                             : moment(userDetails.expiresOn) < moment()
        //                             ? STRING_INVALID_MESSAGE_EXPIRED
        //                             : STRING_INVALID_MESSAGE_ERROR}
        //                     </div>
        //                 )}
        //             </div>
        //         }
        //     />
        // ) : currentInvitationPopup === INVITATION_POPUPS.WITHOUT_CHILD ? (
        //     <HSGModalComponent
        //         show={show || false}
        //         onClose={() => onClose()}
        //         onHide={() => null}
        //         header=""
        //         showClose={true}
        //         bsSize={null}
        //         body={this.invitationModalBodyWithoutChild()}
        //     />
        // ) : null

        return (
            <HSGModalComponent
                show={show || false}
                onClose={() => onClose()}
                onHide={() => null}
                header={
                    showInvitationSendMessage
                        ? STRING_MODAL_HEAD_INVITATION_SEND(hideEmail(this.props.phoneMeta.email || "") || this.state.inEmailAddress)
                        : isInvalidRequest
                        ? STRING_MODAL_HEAD_INVALID
                        : ""
                }
                showClose={true}
                bsSize={null}
                body={
                    <div className="container-fluid">
                        {/* <Loader blockUI={true} isLoading={this.props.isLoading} /> */}
                        {showInvitationSendMessage ? null : !isInvalidRequest ? (
                            this.state.roleTypeId === Constants.roleIdMap.PARENT ? (
                                this.invitationModalBodyParent()
                            ) : (
                                this.invitationModalBodyNonParent()
                            )
                        ) : (
                            <div className="col-xs-12 hsg-invitation-request-modal-root">
                                {userDetails.linkSuccess === Constants.activeStatusMap.ACTIVE
                                    ? STRING_INVALID_MESSAGE_USED
                                    : userDetails.linkSuccess === Constants.activeStatusMap.DRAFT 
                                    ? STRING_INVALID_MESSAGE_LINKED
                                    : moment(userDetails.expiresOn) < moment()
                                    ? STRING_INVALID_MESSAGE_EXPIRED
                                    : STRING_INVALID_MESSAGE_ERROR}
                            </div>
                        )}
                    </div>
                }
            />
        )
    }
}
